exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-div {\n  position: relative;\n  padding: 5px;\n  color: #fff000;\n  margin-left: 40px;\n  margin-top: -10px; }\n\n.customer-form-field {\n  position: relative;\n  color: black; }\n  .customer-form-field::placeholder {\n    font-weight: 450; }\n\n.error-container {\n  position: relative;\n  font-size: 12px;\n  font-weight: 300; }\n\n.arrow-up {\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  position: absolute;\n  top: -10px;\n  border-bottom: 5px solid white; }\n", ""]);

// exports
